<template>
  <div class="rigth-panel">
    <div class="rigth-panel-hader">
      <div class="rigth-panel-header-title">
        <span>PARTICIPANTS</span>
      </div>
      <div class="rigth-panel-header-option">
        <b-button type="is-primary" outlined @click="addNewVotingPartcipant()">ADD PARTICIPANT</b-button>
        <span @click="closeParticipantsMobile">Close</span>
      </div>
    </div>
    <div class="rigth-panel-body">
      <div class="voting-participant-item" v-for="(item, index) in participants" :key="index">
        <div class="voting-participant-item-header">
          <div class="voting-participant-item-image">
            <div class="particant-index">
              {{ item.item_index ? item.item_index : 0 }}
            </div>
            <img v-if="item.profile_image" :src="$store.state.ASSETS_BASE_URL +
              '/assets/uploaded/' +
              item.profile_image
              " />

            <img v-else :src="$store.state.ASSETS_BASE_URL +
              '/assets/uploaded/' +
              session.logo
              " />
          </div>
        </div>
        <div class="voting-participant-item-body">
          <div class="voting-participant-item-title">{{ item.name }}</div>
          <div class="voting-participant-item-option">
            <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
              <template #trigger>
                <b-icon icon="dots-vertical"></b-icon>
              </template>
              <b-dropdown-item @click="updateVotingParticipant(item)" aria-role="listitem">Update</b-dropdown-item>
              <b-dropdown-item @click="deleteVotingParticipant(item)" aria-role="listitem">Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="voting-participant-item-footer">
          <div class="voting-participant-item-footer-left">
            <b-tag v-if="item.status == 'public'" type="is-success">Public</b-tag>
            <b-tag v-if="item.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
          </div>
        </div>
      </div>
    </div>

    <!-- Add voting participant modal -->
    <addNewVotingParticipant v-if="show_addnew_participant_modal" :session_id="session_id" :category_id="category_id"
      :value="selected_participant" @close="show_addnew_participant_modal = false" @saved="onSaved">
    </addNewVotingParticipant>
  </div>
</template>

<script>
import addNewVotingParticipant from "../modals/addNewVotingParticipant.vue";
export default {
  components: {
    addNewVotingParticipant,
  },
  sockets: {},
  props: {
    session: {
      type: Object,
      default: () => { },
    },
    category: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    session_id() {
      let vm = this;
      return vm.session.id;
    },
    category_id() {
      let vm = this;
      return vm.category.id;
    },
  },
  data: () => ({
    show_addnew_participant_modal: false,
    selected_participant: null,
    participants: [],
    loading_voting_participants: false,
  }),
  watch: {
    category_id: function (val) {
      let vm = this;
      vm.getVotingParticipants();
    },
  },
  mounted() {
    let vm = this;
    vm.getVotingParticipants();
  },
  methods: {
    closeParticipantsMobile() {
      let vm = this;
      vm.$emit('close');
    },
    addNewVotingPartcipant() {
      let vm = this;
      vm.selected_participant = null;
      vm.show_addnew_participant_modal = true;
    },
    selectVotingParticipant(item) {
      let vm = this;
      vm.selected_participant = item;
    },
    updateVotingParticipant(item) {
      let vm = this;
      vm.selected_participant = item;
      vm.show_addnew_participant_modal = true;
    },
    deleteVotingParticipant(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Delete",
        message: "Are you sure you want to delete this participant?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("VOTING_DELETE_MY_VOTING_PARTICIPANT", {
              id: item.id,
            })
            .then((res) => {
              vm.$buefy.toast.open({
                message: "Participant deleted successfully!",
                type: "is-success",
              });
              vm.getVotingParticipants();
            })
            .catch((err) => {
              vm.$buefy.toast.open({
                message: "Something went wrong!",
                type: "is-danger",
              });
            });
        },
      });
    },
    getVotingParticipants() {
      let vm = this;
      vm.loading_voting_participants = true;
      vm.$store
        .dispatch("VOTING_GET_MY_VOTING_PARTICIPANTS", {
          session_id: vm.session_id,
          category_id: vm.category_id,
        })
        .then((res) => {
          vm.loading_voting_participants = false;
          vm.participants = res.data.return.sort((a, b) =>
            a.item_index > b.item_index ? 1 : -1
          );
        })
        .catch((err) => {
          vm.loading_voting_participants = false;
          vm.$buefy.toast.open({
            message: "Something went wrong!",
            type: "is-danger",
          });
        });
    },
    onSaved() {
      let vm = this;
      vm.show_addnew_participant_modal = false;
      vm.getVotingParticipants();
    },
  },
};
</script>
<style lang="scss" scoped>
.rigth-panel {
  width: calc(100% - 800px);
  height: 100%;
  border-left: 1px solid #ddd;

  @media (max-width: 1184px) {
    position: absolute;
    background: white;
    z-index: 10;
    top: 60px;
    right: 0;
    width: 45%;
    box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
  }

  @media (max-width: 768px) {
    width: 48%;
  }

  @media (max-width: 592px) {
    width: 70%;
  }

  @media (max-width: 470px) {
    width: 85%;
  }

  .rigth-panel-hader {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding: 0px 10px;
    background: #fff;

    .rigth-panel-header-option {
      display: flex;
      align-items: center;

      span {
        display: none;
        margin-left: 10px;
        color: red;
        font-weight: 700;
        cursor: pointer;

        @media (max-width: 1184px) {
          display: flex;
        }
      }
    }
  }

  .rigth-panel-body {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 20px;
    padding: 15px 10px;
    height: calc(100% - 60px);
    overflow-y: auto;

    .voting-participant-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      border: 1px solid #ddd;
      cursor: pointer;
      height: max-content;
      padding: 10px;
      border-radius: 10px;

      &:hover {
        background: #f5f5f5;
      }

      &.active {
        background: #f5f5f5;
      }

      .voting-participant-item-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .voting-participant-item-image {
          width: 100%;
          height: 150px;
          overflow: hidden;
          border-radius: 10px;
          position: relative;

          .particant-index {
            position: absolute;
            top: 10px;
            left: 10px;
            height: 50px;
            min-width: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background-color: rgba(0, 0, 0, 0.378);
            border-radius: 5px;
            font-size: 20px;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .voting-participant-item-body {
        display: flex;
        justify-content: space-between;
        padding: 10px 0px;

        .voting-participant-item-title {
          font-size: 14px;
          font-weight: 600;
          color: #333;
        }

        .voting-participant-item-option {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 10px;
        }
      }

      .voting-participant-item-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .voting-participant-item-footer-left {
          display: flex;
          align-items: center;
          justify-content: center;

          .voting-participant-item-votes-number {
            font-size: 12px;
            color: #333;
          }
        }

        .voting-participant-item-footer-right {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>